<template>
  <div>
    <b-row>
      <div class="col-md-4 col-sm-12 col-xl-3">
        <input data-v-715a1058="" id="name" type="text" v-model="searchText" placeholder="Filter here" class="form-control"  @keyup="externalFilterChanged" >
      </div>
    </b-row><br>

    <b-modal
      id="trade-revert-confirm"
      title="Confirm Trade Revert"
      ok-title="Revert Trade"
      ok-variant="danger"
      cancel-title="Cancel"
      size="xl"
      dialog-class="trade-revert-confirm-dialog"
      body-class="trade-revert-modal-body"
      scrollable
      @ok="submitRevertTrade"
    >
      <div v-if="pendingRevertTrade">
        <p class="mb-3">
          Trade #{{ pendingRevertTrade.id }} between {{ tradeUserLabel(pendingRevertTrade) }} will be reverted.
        </p>

        <b-row>
          <b-col
            v-for="side in revertPreviewSides(pendingRevertTrade)"
            :key="side.user_id"
            md="6"
            class="mb-3 mb-md-0"
          >
            <div class="trade-revert-side">
              <h6 class="mb-3">
                {{ side.username }}
                <b-badge v-if="side.banned" variant="danger" class="ml-2">
                  {{ side.ban_status || 'Banned' }}
                </b-badge>
              </h6>

              <div class="trade-revert-section" v-if="side.money">
                <strong>Money</strong>
                <div :class="side.money.deltaClass">
                  {{ side.money.deltaLabel }}
                  <span class="trade-revert-current">Current: {{ side.money.before }}</span>
                  <span class="ml-2">New: {{ side.money.after }}</span>
                </div>
              </div>

              <div class="trade-revert-section" v-if="side.items.length > 0">
                <strong>Items</strong>
                <div v-for="item in side.items" :key="'item-' + side.user_id + '-' + item.rowKey" :class="item.deltaClass">
                  {{ item.deltaLabel }} {{ item.item }}
                  <span v-if="item.note" class="trade-revert-item-note">({{ item.note }})</span>
                  <span class="trade-revert-current">Current: {{ item.before }}</span>
                  <span class="ml-2">New: {{ item.after }}</span>
                </div>
              </div>

              <div v-if="!side.money && side.items.length === 0" class="text-muted">
                No money or item changes.
              </div>
            </div>
          </b-col>
        </b-row>

        <div v-if="revertPokemonFlows(pendingRevertTrade).length > 0" class="trade-revert-pokemon-center">
          <div class="trade-revert-pokemon-title">Pokemon</div>
          <div
            v-for="flow in revertPokemonFlows(pendingRevertTrade)"
            :key="flow.key"
            class="trade-revert-flow"
          >
            <div class="trade-revert-arrow" :class="flow.direction"></div>
            <div class="trade-pokemon-card-grid">
              <div v-for="(poke, index) in flow.pokemon" :key="flow.key + '-' + index" class="trade-pokemon-card">
                <div class="trade-pokemon-card-title">{{ pokemonCardTitle(poke) }}</div>
                <div class="trade-pokemon-card-meta">
                  <span v-for="(part, partIndex) in pokemonCardParts(poke)" :key="part + '-' + partIndex">{{ part }}</span>
                </div>
                <div v-if="pokemonDiffs(poke).length > 0" class="trade-pokemon-diffs">
                  <div v-for="diff in pokemonDiffs(poke)" :key="diff.field" class="trade-pokemon-diff">
                    <span class="trade-pokemon-diff-field">{{ diff.field }}</span>
                    <span class="trade-pokemon-diff-before">Before: {{ diff.before }}</span>
                    <span class="trade-pokemon-diff-current">Current: {{ diff.current }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="trade-revert-blocked"
      title="Trade Cannot Be Reverted"
      ok-only
      ok-title="OK"
      size="xl"
      dialog-class="trade-revert-blocked-dialog"
      body-class="trade-revert-modal-body"
      scrollable
    >
      <div v-if="blockedRevertTrade">
        <div class="trade-revert-blocked-reasons">
          <div
            v-for="(reason, index) in revertBlockedReasonLines(blockedRevertTrade)"
            :key="'blocked-reason-' + index"
            class="trade-revert-blocked-reason"
          >
            {{ reason }}
          </div>
        </div>
      </div>
    </b-modal>

    <ag-grid-vue style='width: 100%; height: 800px;' class='ag-theme-balham-dark'
                 :gridOptions='gridOptions'
                 :enableColResize="true"
                 :rowData="records"
                 :enableSorting="true"
                 :masterDetail="true"
                 :detailCellRenderer="detailCellRenderer"
                 :groupDefaultExpanded="groupDefaultExpanded"
                 :suppressClickEdit="true"
                 :isExternalFilterPresent="isExternalFilterPresent"
                 :doesExternalFilterPass="doesExternalFilterPass"
                 :enableFilter="true"
                 :suppressRowClickSelection="true"></ag-grid-vue>

  </div>
</template>
<script>
  import {AgGridVue} from 'ag-grid-vue'
  import 'ag-grid-enterprise'
  import DetailCellRenderer from './detailCellRenderer.js'
  import moment from 'moment'
  import {mapGetters} from 'vuex'
  import {applyGridPersistence} from "@/grid_persistence"

  export default {
    props: ['records', 'server', 'username', 'limit'],
    data () {
      return {
        gridOptions: null,
        searchText: '',
        sortByMoney: false,
        detailCellRendererParams: null,
        detailCellRenderer: null,
        groupDefaultExpanded: null,
        pendingRevertTrade: null,
        blockedRevertTrade: null,
      }
    },
    components: {
      'ag-grid-vue': AgGridVue,
      DetailCellRenderer
    },
    computed: {
      ...mapGetters({
        lastTradeRevert: 'lastTradeRevert'
      })
    },
    methods: {
      onFirstDataRendered(params) {
        params.api.forEachNode(function (node) {
          node.setExpanded(node.id === '1');
        });
      },
      copyStringToClipboard (str) {
        let el = document.createElement('textarea')
        el.value = str
        el.setAttribute('readonly', '')
        el.style = {position: 'absolute', left: '-9999px'}
        document.body.appendChild(el)
        el.select()
        document.execCommand('copy')
        document.body.removeChild(el)
      },
      formatMoney (money) {
        return money.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 0})
      },
      createRowData () {
        return this.records
      },
      externalFilterChanged () {
        this.gridOptions.api.onFilterChanged()
      },
      isExternalFilterPresent () {
        return this.searchText.length !== 0
      },
      doesExternalFilterPass (node) {
        if (this.searchText.length === 0) { return true }
        let lowerText = this.searchText.toLowerCase()
        for (let i in node.data.users) {
          if (node.data.users[i].money.toString().includes(lowerText)) {
            return true
          }
          for (let p in node.data.users[i].pokemon) {
            if (node.data.users[i].pokemon[p].ID != null && node.data.users[i].pokemon[p].ID.toString().includes(lowerText)) {
              return true
            }
            if (node.data.users[i].pokemon[p].Pokemon != null && node.data.users[i].pokemon[p].Pokemon.toLowerCase().includes(lowerText)) {
              return true
            }
            if (node.data.users[i].pokemon[p].Item != null && node.data.users[i].pokemon[p].Item.toLowerCase().includes(lowerText)) {
              return true
            }
          }
          for (let p in node.data.users[i].items) {
            if (node.data.users[i].items[p].item.toLowerCase().includes(lowerText)) {
              return true
            }
          }
        }
        return false
      },
      onGridSizeChanged () {
        this.gridOptions.api.sizeColumnsToFit()
      },
      tradeUserLabel (trade) {
        if (!trade || !trade.users) {
          return 'Unknown users'
        }
        return trade.users.map(user => user.username || 'Unknown').join(' <> ')
      },
      getRevertBlockedReason (trade) {
        if (!this.hasPermission('TradelogsRevert')) {
          return 'You do not have permission to revert trades.'
        }
        const reason = (trade && trade.revert_blocked_reason) || 'This trade cannot be reverted.'
        if (reason.includes('This trade was already reverted.')) {
          return 'This trade was already reverted.'
        }
        return reason
      },
      revertBlockedReasonLines (trade) {
        return this.getRevertBlockedReason(trade)
          .split('\n')
          .map(reason => reason.trim())
          .filter(reason => reason.length > 0)
      },
      pokemonLabel (poke) {
        let parts = []
        if (poke.Special === 1) {
          parts.push('Shiny')
        }
        parts.push(`${poke.Pokemon || 'Unknown Pokemon'} Lv. ${poke.LVL || '-'}`)
        if (poke.Item) {
          parts.push(`(${poke.Item})`)
        }
        if (poke.Form && poke.Form > 0) {
          parts.push(`Form: ${poke.Form}`)
        }
        if (poke.Nature) {
          parts.push(`${poke.Nature},`)
        }
        if (poke.Ability) {
          parts.push(poke.Ability)
        }
        if (poke.ID) {
          parts.push(`UID: ${poke.ID}`)
        }
        if (poke.GID) {
          parts.push(`GID: ${poke.GID}`)
        }
        if (poke.Username) {
          parts.push(`Current Owner: ${poke.Username}`)
        }
        if (poke.IV_ATK) {
          parts.push(`IVs: ${poke.IV_ATK}, ${poke.IV_DEF}, ${poke.IV_SPD}, ${poke.IV_SPATK}, ${poke.IV_SPDEF}, ${poke.IV_HP}`)
        }
        if (poke.EV_ATK != null) {
          parts.push(`EVs: ${poke.EV_ATK}, ${poke.EV_DEF}, ${poke.EV_SPD}, ${poke.EV_SPATK}, ${poke.EV_SPDEF}, ${poke.EV_HP}`)
        }
        if (poke.ID && !poke.Username) {
          parts.push('(ID NOT FOUND)')
        }
        return parts.join(' ')
      },
      userName (user) {
        return (user && user.username) || 'Unknown'
      },
      pokemonCurrent (poke) {
        return (poke && poke.current) || {}
      },
      pokemonValue (poke, field, fallbackField) {
        const current = this.pokemonCurrent(poke)
        if (current[field] !== undefined && current[field] !== null && current[field] !== '') {
          return current[field]
        }
        const fallback = fallbackField || field
        return poke ? poke[fallback] : null
      },
      pokemonCardTitle (poke) {
        let parts = []
        if (poke && poke.Special === 1) {
          parts.push('Shiny')
        }
        parts.push(this.pokemonValue(poke, 'Pokemon') || 'Unknown Pokemon')
        const level = this.pokemonValue(poke, 'LVL')
        if (level !== undefined && level !== null && level !== '') {
          parts.push(`Lv. ${level}`)
        }
        return parts.join(' ')
      },
      pokemonStatLine (label, values) {
        if (!values.some(value => value !== undefined && value !== null)) {
          return null
        }
        return `${label}: ${values.map(value => value === undefined || value === null ? '-' : value).join(', ')}`
      },
      pokemonCardParts (poke) {
        const current = this.pokemonCurrent(poke)
        let parts = []
        const heldItem = this.pokemonValue(poke, 'Item')
        if (heldItem) {
          parts.push(`Held: ${heldItem}`)
        }
        const form = this.pokemonValue(poke, 'Form')
        if (form && form > 0) {
          parts.push(`Form: ${form}`)
        }
        if (poke.Nature) {
          parts.push(`Nature: ${poke.Nature}`)
        }
        if (poke.Ability) {
          parts.push(`Ability: ${poke.Ability}`)
        }
        if (this.pokemonValue(poke, 'ID')) {
          parts.push(`UID: ${this.pokemonValue(poke, 'ID')}`)
        }
        if (poke.GID) {
          parts.push(`GID: ${poke.GID}`)
        }
        const owner = current.Username || poke.Username
        if (owner) {
          parts.push(`Current Owner: ${owner}`)
        }
        const position = current.Position
        if (position !== undefined && position !== null) {
          parts.push(`Position: ${position}`)
        }
        const ivs = this.pokemonStatLine('IVs', [poke.IV_ATK, poke.IV_DEF, poke.IV_SPD, poke.IV_SPATK, poke.IV_SPDEF, poke.IV_HP])
        if (ivs) {
          parts.push(ivs)
        }
        const evs = this.pokemonStatLine('EVs', [
          current.EV_ATK !== undefined && current.EV_ATK !== null ? current.EV_ATK : poke.EV_ATK,
          current.EV_DEF !== undefined && current.EV_DEF !== null ? current.EV_DEF : poke.EV_DEF,
          current.EV_SPD !== undefined && current.EV_SPD !== null ? current.EV_SPD : poke.EV_SPD,
          current.EV_SPATK !== undefined && current.EV_SPATK !== null ? current.EV_SPATK : poke.EV_SPATK,
          current.EV_SPDEF !== undefined && current.EV_SPDEF !== null ? current.EV_SPDEF : poke.EV_SPDEF,
          current.EV_HP !== undefined && current.EV_HP !== null ? current.EV_HP : poke.EV_HP
        ])
        if (evs) {
          parts.push(evs)
        }
        if (poke.ID && !owner) {
          parts.push('ID NOT FOUND')
        }
        return parts
      },
      pokemonDiffs (poke) {
        return (poke && poke.current_diffs) || []
      },
      signedClass (delta) {
        return delta >= 0 ? 'text-success' : 'text-danger'
      },
      signedMoneyLabel (delta) {
        return `${delta >= 0 ? '+' : '-'}${this.formatMoney(Math.abs(delta))}`
      },
      signedQtyLabel (delta) {
        return `${delta >= 0 ? '+' : '-'}${Math.abs(delta)}x`
      },
      currentItemCount (user, itemId) {
        if (!user || !user.item_inventory || itemId === undefined || itemId === null) {
          return 0
        }
        return user.item_inventory[itemId] || user.item_inventory[String(itemId)] || 0
      },
      itemKey (item) {
        return item.item_id || item.item
      },
      addItemDelta (items, sourceItems, multiplier) {
        if (!sourceItems) {
          return
        }
        sourceItems.forEach(item => {
          const key = this.itemKey(item)
          if (!items[key]) {
            items[key] = {
              item_id: item.item_id,
              item: item.item,
              delta: 0
            }
          }
          items[key].delta += Number(item.qty || 0) * multiplier
        })
      },
      itemPreviewRow (user, entry, delta, totalDelta, note, index) {
        const before = this.currentItemCount(user, entry.item_id)
        const itemName = entry.item || entry.item_id || 'Unknown Item'
        return {
          rowKey: `${entry.item_id || entry.item}-${note || 'trade'}-${index}`,
          item_id: entry.item_id,
          item: itemName,
          delta: delta,
          deltaClass: this.signedClass(delta),
          deltaLabel: this.signedQtyLabel(delta),
          before: before,
          after: before + totalDelta,
          note: note
        }
      },
      revertItemRows (user, partner) {
        let totalMap = {}
        let tradeMap = {}
        let rows = []

        this.addItemDelta(totalMap, user.items, 1)
        this.addItemDelta(totalMap, partner.items, -1)
        this.addItemDelta(totalMap, user.revert_item_adjustments, 1)
        this.addItemDelta(tradeMap, user.items, 1)
        this.addItemDelta(tradeMap, partner.items, -1)

        Object.keys(tradeMap).forEach((key, index) => {
          const entry = tradeMap[key]
          if (entry.delta === 0) {
            return
          }
          const total = totalMap[key] ? totalMap[key].delta : entry.delta
          rows.push(this.itemPreviewRow(user, entry, entry.delta, total, '', index))
        })

        if (user.revert_item_adjustments) {
          user.revert_item_adjustments.forEach((item, index) => {
            const delta = Number(item.qty || 0)
            if (delta === 0) {
              return
            }
            const key = this.itemKey(item)
            const total = totalMap[key] ? totalMap[key].delta : delta
            rows.push(this.itemPreviewRow(
              user,
              item,
              delta,
              total,
              delta > 0 ? 'Pokemon held item removed' : 'Pokemon held item added',
              index
            ))
          })
        }

        return rows.sort((a, b) => {
          if (a.item === b.item) {
            return (a.note || '').localeCompare(b.note || '')
          }
          return String(a.item).localeCompare(String(b.item))
        })
      },
      revertPokemonFlows (trade) {
        if (!trade || !trade.users || trade.users.length !== 2) {
          return []
        }
        const left = trade.users[0]
        const right = trade.users[1]
        const leftName = this.userName(left)
        const rightName = this.userName(right)
        return [
          {
            key: 'left-to-right',
            direction: 'left-to-right',
            from: leftName,
            to: rightName,
            pokemon: right.pokemon || []
          },
          {
            key: 'right-to-left',
            direction: 'right-to-left',
            from: rightName,
            to: leftName,
            pokemon: left.pokemon || []
          }
        ].filter(flow => flow.pokemon.length > 0)
      },
      revertPreviewSides (trade) {
        if (!trade || !trade.users || trade.users.length !== 2) {
          return []
        }
        return trade.users.map((user, index) => {
          const partner = trade.users[index === 0 ? 1 : 0]
          const userName = user.username || 'Unknown'
          const moneyDelta = (user.money || 0) - (partner.money || 0)
          const currentMoney = user.current_money || 0

          return {
            user_id: user.user_id || index,
            username: userName,
            banned: user.banned,
            ban_status: user.ban_status,
            money: moneyDelta === 0 ? null : {
              deltaClass: this.signedClass(moneyDelta),
              deltaLabel: this.signedMoneyLabel(moneyDelta),
              before: this.formatMoney(currentMoney),
              after: this.formatMoney(currentMoney + moneyDelta)
            },
            items: this.revertItemRows(user, partner)
          }
        })
      },
      confirmRevertTrade (trade) {
        if (!trade) {
          return
        }
        if (!trade.can_revert || !this.hasPermission('TradelogsRevert')) {
          this.blockedRevertTrade = trade
          this.$bvModal.show('trade-revert-blocked')
          return
        }
        this.pendingRevertTrade = trade
        this.$bvModal.show('trade-revert-confirm')
      },
      submitRevertTrade () {
        if (!this.pendingRevertTrade) {
          return
        }
        this.emit('revertTrade', {
          trade_id: this.pendingRevertTrade.id,
          server: this.server,
          username: this.username || this.$route.params.username,
          limit: this.limit || 100
        })
      },
      renderRevertButton (params) {
        if (!params.data) {
          return ''
        }
        if (params.data.is_mail || params.data.lending !== 0) {
          return ''
        }

        const button = document.createElement('button')
        const canRevert = params.data.can_revert && this.hasPermission('TradelogsRevert')
        button.type = 'button'
        button.className = canRevert ? 'btn btn-sm btn-danger py-0' : 'btn btn-sm btn-secondary py-0 trade-revert-button-blocked'
        button.title = canRevert ? 'Revert trade' : this.getRevertBlockedReason(params.data)
        button.innerHTML = '<i class="fa fa-undo mr-1"></i>Revert'
        button.addEventListener('click', event => {
          event.preventDefault()
          event.stopPropagation()
          this.confirmRevertTrade(params.data)
        })
        return button
      },
      applyTradeRevertUpdate (trade) {
        if (!trade || trade.server !== this.server || !this.gridOptions || !this.gridOptions.api) {
          return
        }

        const reason = this.getRevertBlockedReason(trade)
        let rowNode = null
        this.gridOptions.api.forEachNode(node => {
          if (!rowNode && node.data && node.data.id === trade.trade_id) {
            rowNode = node
          }
        })
        if (!rowNode) {
          return
        }

        this.$set(rowNode.data, 'can_revert', false)
        this.$set(rowNode.data, 'revert_blocked_reason', reason)
        if (this.pendingRevertTrade && this.pendingRevertTrade.id === trade.trade_id) {
          this.$set(this.pendingRevertTrade, 'can_revert', false)
          this.$set(this.pendingRevertTrade, 'revert_blocked_reason', reason)
        }
        this.gridOptions.api.refreshCells({
          rowNodes: [rowNode],
          columns: ['can_revert'],
          force: true
        })
      },
      getContextMenuItems: function getContextMenuItems (params) {
        let self = this
        return [
          {
            name: 'Copy',
            action: function () {
              let data = params.node.data
              let clipboard = 'Trade - '
              if (data.is_mail) {
                clipboard = 'Mail Trade - '
              }
              if (data.lending > 0) {
                clipboard = 'Lending Trade - '
              }
              clipboard += (self.username || self.$route.params.username) + ' <> ' + data.trade_partner + ' - ' + moment(data.date).utc().toString() + '\r\n'
              for (let i in data.users) {
                let user = data.users[i]
                clipboard += '#' + user.username + '\r\n'
                if (user.money > 0) {
                  clipboard += self.formatMoney(user.money) + '\r\n'
                }
                for (let p in user.pokemon) {
                  let poke = user.pokemon[p]
                  if (poke.Special === 1) {
                    clipboard += 'Shiny '
                  }
                  clipboard += poke.Pokemon + ' Lvl. ' + poke.LVL + ' '
                  if (poke.Item) {
                    clipboard += '(' + poke.Item + ') '
                  }
                  if (poke.Form && poke.Form > 0) {
                    clipboard += 'Form: ' + poke.Form + ' '
                  }
                  if (poke.ID) {
                    clipboard += 'UID: ' + poke.ID + ' '
                  }
                  if (poke.GID) {
                    clipboard += 'GID: ' + poke.GID + ' '
                  }
                  clipboard += '\r\n'
                }
                if (user.items && user.pokemon) {
                  clipboard += '\r\n'
                }
                for (let x in user.items) {
                  let item = user.items[x]
                  clipboard += item.qty + 'x ' + item.item
                  clipboard += '\r\n'
                }
                clipboard += '\r\n'
              }
              self.copyStringToClipboard(clipboard)
            }
          },
          'separator',
          'toolPanel',
          'export'
        ]
      },
      createColumnDefs () {
        const columns = [
          {
            headerName: 'ID',
            field: 'id',
            cellRenderer: 'agGroupCellRenderer'
          },
          {
            headerName: 'Username',
            filter: 'agSetColumnFilter',
            field: 'trade_partner'
          },
          {
            headerName: 'Lending',
            field: 'lending',
            valueGetter (params) {
              switch (params.data.lending) {
                case 0:
                  return 'None'
                case 1:
                  return 'Start'
                case 2:
                  return 'Returned'
              }
              return params.data.lending
            }
          },
          {
            headerName: 'Lending End',
            field: 'lending_date',
            filter: 'agDateColumnFilter',
            cellRenderer: params => this.formatDateDisplay(params.value),
            tooltipValueGetter: params => {
              if (!params.value) return '';
              const m = moment(params.value);
              return `Local: ${m.local().format('YYYY-MM-DD HH:mm:ss')}`;
            }
          },
          {
            headerName: 'Mail',
            field: 'is_mail'
          },
          {
            headerName: 'Date',
            field: 'date',
            sortable: true,
            sort: 'desc',
            filter: 'agDateColumnFilter',
            cellRenderer: params => this.formatDateDisplay(params.value),
            tooltipValueGetter: params => {
              if (!params.value) return '';
              const m = moment(params.value);
              return `Local: ${m.local().format('YYYY-MM-DD HH:mm:ss')}`;
            }
          }
        ]

        if (this.hasPermission('TradelogsRevert')) {
          columns.push({
            headerName: 'Actions',
            field: 'can_revert',
            width: 130,
            pinned: 'right',
            suppressMenu: true,
            sortable: false,
            filter: false,
            cellRenderer: params => this.renderRevertButton(params)
          })
        }

        return columns
      }
    },

    beforeMount () {
      this.groupDefaultExpanded = 1
      this.detailCellRenderer = 'DetailCellRenderer';

      this.gridOptions = {
        suppressRowClickSelection: true,
        rowSelection: 'multiple',
        suppressNoRowsOverlay: false,
        masterDetail: true,
        enableRangeSelection: true,
        suppressMovable: false,
        defaultColDef: {
          resizable: true,
          sortable: true,
          filter: true
        },
        onFirstDataRendered: (params) => { params.api.sizeColumnsToFit() },
        getContextMenuItems: this.getContextMenuItems,
        getRowHeight: function (params) {
          if (params.node && params.node.detail) {
            let totalCalc = 0

            for (let i in params.data.users) {
              let calc = 0
              if (params.data.users[i].money > 0) {
                calc += 28
              }
              if (params.data.users[i].pokemon) {
                calc += params.data.users[i].pokemon.length * 28
              }
              if (params.data.users[i].items) {
                calc += params.data.users[i].items.length * 18
              }
              if (calc > totalCalc) {
                totalCalc = calc
              }
            }
            return totalCalc + 80
          }
          return 28
        }
      }
      applyGridPersistence(this.gridOptions, 'user-tradelog-grid')
      this.gridOptions.rowData = this.createRowData()
      this.gridOptions.columnDefs = this.createColumnDefs()
    },
    watch: {
      lastTradeRevert (trade) {
        this.applyTradeRevertUpdate(trade)
      }
    },
    mounted () {
      this.gridOptions.api.forEachNode(node => {
        node.setExpanded(true)
      })
    }
  }
</script>

<style>
.trade-revert-confirm-dialog,
.trade-revert-blocked-dialog {
  margin: 12px auto;
  max-width: calc(100vw - 24px);
  width: 1180px;
}

.trade-revert-confirm-dialog .modal-content,
.trade-revert-blocked-dialog .modal-content {
  max-height: calc(100vh - 24px);
}

.trade-revert-modal-body {
  overflow-y: auto;
}

.trade-revert-side {
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  padding-top: 12px;
}

.trade-revert-section {
  margin-bottom: 14px;
}

.trade-revert-pokemon {
  margin-top: 8px;
}

.trade-revert-pokemon-center {
  margin-top: 18px;
  text-align: center;
}

.trade-revert-pokemon-title {
  color: #f0f3f5;
  font-weight: 700;
  margin-bottom: 10px;
  text-transform: uppercase;
  letter-spacing: 0.8px;
}

.trade-revert-flow {
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  width: 100%;
}

.trade-revert-arrow {
  color: #e4e7ea;
  height: 24px;
  margin: 0 auto 12px;
  max-width: 680px;
  position: relative;
  width: 100%;
}

.trade-revert-arrow::before {
  border-top: 2px solid #e4e7ea;
  content: "";
  left: 22px;
  position: absolute;
  right: 22px;
  top: 50%;
}

.trade-revert-arrow::after {
  content: "";
  height: 12px;
  position: absolute;
  top: 50%;
  width: 12px;
}

.trade-revert-arrow.left-to-right::after {
  border-right: 2px solid #e4e7ea;
  border-top: 2px solid #e4e7ea;
  right: 18px;
  transform: translateY(-50%) rotate(45deg);
}

.trade-revert-arrow.right-to-left::after {
  border-bottom: 2px solid #e4e7ea;
  border-left: 2px solid #e4e7ea;
  left: 18px;
  transform: translateY(-50%) rotate(45deg);
}

.trade-pokemon-card-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  margin: 0 auto;
  max-width: 980px;
  width: 100%;
}

.trade-pokemon-card {
  background: #23282c;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  color: #ffffff;
  max-width: 320px;
  min-width: 250px;
  padding: 12px;
  text-align: left;
}

.trade-pokemon-card-title {
  color: #ffffff;
  font-weight: 700;
  margin-bottom: 8px;
}

.trade-pokemon-card-meta {
  color: #ffffff;
  display: flex;
  flex-wrap: wrap;
  gap: 5px 10px;
  font-size: 12px;
}

.trade-pokemon-card-meta span {
  color: #ffffff;
}

.trade-pokemon-diffs {
  margin-top: 10px;
}

.trade-pokemon-diff {
  border-left: 3px solid #f0ad4e;
  background: rgba(240, 173, 78, 0.08);
  margin-top: 6px;
  padding: 6px 8px;
}

.trade-pokemon-diff-field {
  color: #f0f3f5;
  display: block;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
}

.trade-pokemon-diff-before,
.trade-pokemon-diff-current {
  color: #ffffff;
  display: block;
  font-size: 12px;
}

.trade-pokemon-diff-before {
  opacity: 0.78;
  text-decoration: line-through;
}

.trade-revert-current {
  margin-left: 8px;
  opacity: 0.75;
  text-decoration: line-through;
}

.trade-revert-item-note {
  color: #adb5bd;
  font-size: 12px;
  margin-left: 4px;
}

.trade-revert-blocked-reasons {
  margin-bottom: 12px;
}

.trade-revert-blocked-reason {
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  color: #f0f3f5;
  padding: 10px 0 0;
  white-space: pre-wrap;
}

.trade-revert-blocked-reason + .trade-revert-blocked-reason {
  margin-top: 10px;
}

.trade-revert-button-blocked {
  opacity: 0.65;
}

@media (max-width: 575.98px) {
  .trade-revert-confirm-dialog,
  .trade-revert-blocked-dialog {
    margin: 8px auto;
    max-width: calc(100vw - 16px);
  }

  .trade-revert-confirm-dialog .modal-content,
  .trade-revert-blocked-dialog .modal-content {
    max-height: calc(100vh - 16px);
  }

  .trade-pokemon-card {
    min-width: 0;
    width: 100%;
  }
}
</style>
